import { StoreThemeFormValues } from './storeTheme.types';

export const defaultStoreTheme: StoreThemeFormValues = {
  defaultBanner: '',
  sections: [],
  tabs: [],
  buttonColor: {
    colorOne: '#7122ff',
    colorTwo: ''
  },
  buttonTextColor: 'white',
  addToHomeScreen: {
    active: false,
    buttonImage: '',
    iconImage: 'https://media.appcharge.com/defaults/default-store-logo.svg',
    shortcutName: 'Gaming Store',
    borderColor: {
      colorOne: '#ffffff'
    },
    backgroundColor: {
      colorOne: '#522AD8',
      colorTwo: ''
    }
  },
  backToGameButton: {
    active: false,
    buttonImage: ''
  },
  header: {
    backgroundOpacity: 40,
    showLogo: true,
    showPlayerName: true,
    isSticky: false
  },
  noOffersTitleText: 'No Offers Available',
  noOffersMessageText: 'No offers are available at the moment. Try again soon!',
  bundleBorderColor: {
    colorOne: '#e3d3ff',
    colorTwo: ''
  },
  defaultPlayerImage: 'https://media.appcharge.com/defaults/old-profile.png',
  richText: {
    text: '',
    fontColor: 'rgb(0, 0, 0)',
  }
};
